import { Component } from '@angular/core';

@Component({
  selector: 'grow-today-phrase',
  templateUrl: './grow-today-phrase.component.html',
  styleUrls: ['./grow-today-phrase.component.css']
})
export class GrowTodayPhraseComponent {
  icons = {
    money: 'assets/icons/money.svg',
    buttonCircle: 'assets/icons/button-circle.svg'
  };
}
